import React from 'react';
import Login from '../Login';
import { useAuth } from "../contexts/AuthContext";

const LoginTooltip = ({ 
  isOpen, 
  onClose, 
  message = "Please log in to continue.",
  position = "bottom-right" // bottom-right, bottom-left, top-right, top-left
}) => {
  const { isAuthenticated } = useAuth();
  if (isAuthenticated || !isOpen) return null;

  // Position classes based on prop
  const positionClasses = {
    'bottom-right': 'top-full right-0 mt-2',
    'bottom-left': 'top-full left-0 mt-2', 
    'top-right': 'bottom-full right-0 mb-2',
    'top-left': 'bottom-full left-0 mb-2'
  };

  // Arrow classes based on position
  const arrowClasses = {
    'bottom-right': 'absolute bottom-full right-4 transform',
    'bottom-left': 'absolute bottom-full left-4 transform',
    'top-right': 'absolute top-full right-4 transform',
    'top-left': 'absolute top-full left-4 transform'
  };

  // Arrow border classes based on position
  const arrowBorderClasses = {
    'bottom-right': 'border-4 border-transparent border-b-black',
    'bottom-left': 'border-4 border-transparent border-b-black',
    'top-right': 'border-4 border-transparent border-t-black',
    'top-left': 'border-4 border-transparent border-t-black'
  };

  return (
    <div className={`absolute z-50 bg-white rounded-lg shadow-lg border p-3 w-80 ${positionClasses[position]}`}>
      <div className="flex justify-between items-center mb-3">
        <h3 className="text-lg font-semibold">Login Required</h3>
        <button
          onClick={(e) => {
            e.stopPropagation();
            onClose();
          }}
          className="text-gray-400 hover:text-gray-600"
        >
          ✕
        </button>
      </div>
      <p className="mb-3 text-gray-600 text-sm">{message}</p>
      <Login />
      {/* Tooltip arrow */}
      <div className={arrowClasses[position]}>
        <div className={arrowBorderClasses[position]}></div>
      </div>
    </div>
  );
};

export default LoginTooltip;
